/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Collapsed/BoardsList/Loading"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 height={40}
 width={40}
 delay={100}
/>
</div>
{children}
</React.Fragment>)
}